import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [
    NgIf,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule
  ],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {

  @Input() public type;
  @Input() public color;
  @Input() public label;
  @Input() public iconColor;
  @Input() public iconName;
  @Input() public icon;
  @Input() public suffixIcon?;
  @Input() public btnClass;
  @Input() public isLoading;
  @Input() public disabled;
  @Input() public externalIcon = false;
  @Output() btnClick = new EventEmitter();

  onBtnClick(event: any) {
    this.btnClick.emit(event);
  }

}